export default {"LABEL":"Colors 色彩","DESC":"色彩的定义为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。","COMPONENTS":{"__markdown":true}}